export const ADD_TO_WISHLIST_TYPE = 'ADD_TO_WISHLIST';
export const ADD_TO_WISHLIST_PENDING = `${ADD_TO_WISHLIST_TYPE}_PENDING`;
export const ADD_TO_WISHLIST_FULFILLED = `${ADD_TO_WISHLIST_TYPE}_FULFILLED`;
export const ADD_TO_WISHLIST_REJECTED = `${ADD_TO_WISHLIST_TYPE}_REJECTED`;
export const FETCH_WISHLIST_TYPE = 'FETCH_WISHLIST';
export const FETCH_WISHLIST_PENDING = `${FETCH_WISHLIST_TYPE}_PENDING`;
export const FETCH_WISHLIST_FULFILLED = `${FETCH_WISHLIST_TYPE}_FULFILLED`;
export const FETCH_WISHLIST_REJECTED = `${FETCH_WISHLIST_TYPE}_REJECTED`;
export const REMOVE_FROM_WISHLIST_TYPE = 'REMOVE_FROM_WISHLIST';
export const REMOVE_FROM_WISHLIST_PENDING = `${REMOVE_FROM_WISHLIST_TYPE}_PENDING`;
export const REMOVE_FROM_WISHLIST_FULFILLED = `${REMOVE_FROM_WISHLIST_TYPE}_FULFILLED`;
export const REMOVE_FROM_WISHLIST_REJECTED = `${REMOVE_FROM_WISHLIST_TYPE}_REJECTED`;
export const WISHLIST_TOGGLE = 'WISHLIST_TOGGLE';

export const addToWishlistCreator = (sku, promise) => ({
  meta: { sku },
  type: ADD_TO_WISHLIST_TYPE,
  payload: promise,
});

export const fetchWishlistActionCreator = promise => ({
  type: FETCH_WISHLIST_TYPE,
  payload: promise,
});

export const removeFromWishlistCreator = (sku, promise) => ({
  meta: { sku },
  type: REMOVE_FROM_WISHLIST_TYPE,
  payload: promise,
});

export const wishlistToggleCreator = sku => ({
  type: WISHLIST_TOGGLE,
  payload: { sku },
});
